type RawMessage = any;

function parseToolResult(content: any): any {
  if (content && typeof content === "object") return content;
  if (typeof content !== "string") return null;
  try {
    return JSON.parse(content);
  } catch {
    return null;
  }
}

export function buildToolResultMap(history: RawMessage[]): Map<string, any> {
  const results = new Map<string, any>();
  history.forEach((raw) => {
    if (raw?.role === "tool" && raw?.tool_call_id) {
      results.set(raw.tool_call_id, parseToolResult(raw.content));
    }
  });
  return results;
}

export function messageToolCallFailed(results: Map<string, any>, call: any): boolean {
  if (!call?.id || !results.has(call.id)) return false;
  const result = results.get(call.id);
  if (!result || typeof result !== "object") return false;
  return result.success === false
    || Number(result.status) >= 400
    || Boolean(result.erro)
    || Boolean(result.error)
    || result.code === "MESSAGE_TOOL_REQUIRES_SEPARATE_ROUND";
}
